exports.DATEFORMAT = 'DD-MM-YYYY';
exports.INTERNAL_DATEFORMAT = 'YYYY-MM-DD';
exports.ICAL_DATEFORMAT = 'YYYYMMDD';
